import { Grid2 } from "@mui/material";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../Hooks/useWorker";
import Button from "../../../../UI/GeneralPurpose/Button";
import c365fullRepoChange, { allDeSelectId, allSelectId } from "../Actions/c365fullRepoChange";
import { tunnelTokenId } from "../Actions/getMachineStatus";

const UIText = {
  "es-CL": { label: "Deseleccionar todo" },
  "en-US": { label: "Deselect All" },
};
const UIText2 = {
  "es-CL": { label: "Seleccionar todo" },
  "en-US": { label: "Select All" },
};


const AllDeSelect = ({user}) => {
  const { auth,dispatch,UI, settings } = useUIBp();
  const locale = settings.locale || "es-CL";
  const tunnelToken = UI[tunnelTokenId];
  const { working } = useWorker(allSelectId)
  const { working:w2} = useWorker(allDeSelectId)


const handleDeSelectAll = () => {
  dispatch(c365fullRepoChange({...auth, user, tunnelToken, locale}))
}

const handleSelectAll = () => {
  dispatch(c365fullRepoChange({...auth, user, selectAll:true, tunnelToken, locale}))
}

let disabled = working || w2;

  return <Grid2 container size="grow" spacing={1} >
    <Button {...{ working, disabled, UIText:UIText2, onClick: handleSelectAll, variant:"outlined"}} />
    <Button {...{working:w2, disabled, UIText, onClick: handleDeSelectAll, variant:"outlined"}} />
  </Grid2>;
}

export default AllDeSelect;